import moment from 'moment';

const normalizeCreditTypes = (creditTypes) => {
  if (Array.isArray(creditTypes)) {
    return creditTypes.filter(Boolean);
  }
  if (creditTypes) {
    return [creditTypes];
  }
  return [];
};

const shouldApplyCreditTypeFilter = (
  selectedCreditTypes,
  availableCreditTypes
) => {
  if (!selectedCreditTypes.length) {
    return false;
  }

  const available = normalizeCreditTypes(availableCreditTypes);
  if (!available.length) {
    return true;
  }

  if (selectedCreditTypes.length !== available.length) {
    return true;
  }

  const availableSet = new Set(available);
  return selectedCreditTypes.some((type) => !availableSet.has(type));
};

export const buildCreditHistoryQuery = ({
  pagination,
  sort,
  filters,
  availableCreditTypes = [],
}) => {
  const params = {
    limit: pagination.limit,
    page: pagination.page,
    sort,
  };

  const selectedCreditTypes = normalizeCreditTypes(filters.creditType);
  if (shouldApplyCreditTypeFilter(selectedCreditTypes, availableCreditTypes)) {
    params.credit_type = selectedCreditTypes;
  }

  if (filters.bookingId) {
    params.booking_id = filters.bookingId;
  }

  if (
    Array.isArray(filters.createdAtRange) &&
    filters.createdAtRange.length === 2
  ) {
    const [startDate, endDate] = filters.createdAtRange;
    if (startDate) {
      params.from = moment(startDate).startOf('day').format('YYYY-MM-DD');
    }
    if (endDate) {
      params.to = moment(endDate).endOf('day').format('YYYY-MM-DD');
    }
  }

  return params;
};
